import { Link } from "react-router-dom";
import { MapPin, Sparkles, BadgeCheck } from "lucide-react";
import StarRating from "./StarRating";
import FavoriteButton from "./FavoriteButton";
import OpenStatusBadge from "./OpenStatusBadge";
import { getCategory } from "../lib/constants";

export default function BusinessCard({ business }) {
  const cat = getCategory(business.category_slug);

  return (
    <Link
      to={`/business/${business.slug}`}
      className="biz-card group block relative"
      data-testid={`business-card-${business.slug}`}
    >
      {/* category accent bar */}
      <div className="h-1.5 w-full" style={{ background: cat.color }} />

      {/* favorite heart */}
      <div className="absolute top-3 right-3 z-10">
        <FavoriteButton businessId={business.id} compact />
      </div>

      {/* cover */}
      <div className="relative aspect-[16/10] w-full overflow-hidden" style={{ background: `${cat.color}14` }}>
        {business.cover_image_url ? (
          <img
            src={business.cover_image_url.startsWith("http") ? business.cover_image_url : `${process.env.REACT_APP_BACKEND_URL}${business.cover_image_url}`}
            alt={business.name}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-6xl" style={{ background: `${cat.color}22` }}>
            <span>{cat.emoji}</span>
          </div>
        )}

        <div className="absolute top-3 left-3 flex flex-wrap gap-2">
          {business.is_featured && (
            <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold bg-lokaso-gold text-lokaso-dark shadow">
              <Sparkles className="w-3 h-3" /> Mis en avant
            </span>
          )}
          {business.is_verified && (
            <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold bg-white text-lokaso-green shadow">
              <BadgeCheck className="w-3 h-3" /> Vérifié
            </span>
          )}
        </div>

        <div className="absolute bottom-3 right-3">
          <OpenStatusBadge hours={business.hours} />
        </div>
      </div>

      {/* content */}
      <div className="p-4 flex flex-col gap-2 flex-1">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-display text-lg font-bold leading-tight text-lokaso-dark line-clamp-1">
            {business.name}
          </h3>
          {business.price_range && (
            <span className="text-sm font-semibold text-stone-500 shrink-0">{business.price_range}</span>
          )}
        </div>

        <StarRating rating={business.avg_rating} count={business.review_count} />

        <div className="flex items-center gap-1.5 text-sm text-stone-600">
          <MapPin className="w-3.5 h-3.5" />
          <span className="line-clamp-1">
            {business.neighborhood_name || "—"} · {business.city_slug ? business.city_slug.charAt(0).toUpperCase() + business.city_slug.slice(1) : ""}
          </span>
        </div>

        {business.tags && business.tags.length > 0 && (
          <div className="flex flex-wrap gap-1.5 pt-1">
            {business.tags.slice(0, 3).map((t) => (
              <span key={t} className="px-2 py-0.5 rounded-full text-[11px] bg-lokaso-cream text-stone-700 border border-stone-200">
                {t}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}
